/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React, { Component } from 'react'
import injectSheet from 'react-jss'
// eslint-disable-next-line lodash-fp/consistent-name, lodash-fp/use-fp
import { map } from 'lodash'
import $ from 'jquery'
import LockedIcon from '../../assets/icons/nav_bar/section_locked.svg'
import style from './style'

/**
 * A sidebar menu that contains routes to different paths, overlays on mobile
 */

class Menu extends Component {
  state = {
    activeTopMenuItem: null,
    activeSubMenu: null,
    activeItemIndex: null,
    isTopScrollClassAdded: false,
    isBottomScrollClassAdded: false
  }

  componentDidMount() {
    const menuBase = document.getElementsByClassName('menuBase')[0]
    menuBase.addEventListener('scroll', () => this.checkSideBarShadows())
    window.addEventListener('resize', () => this.checkSideBarShadows())
    this.checkSideBarShadows()
  }

  componentWillUnmount() {
    const menuBase = document.getElementsByClassName('menuBase')[0]
    menuBase.removeEventListener('scroll', () => this.checkSideBarShadows())
    window.removeEventListener('resize', () => this.checkSideBarShadows())
  }

  componentDidUpdate() {
    this.checkSideBarShadows()

    const { classes } = this.props
    let $current = $('.menuBase').find('ul')
    let $desc = $current
    while ($desc.length) {
      $current = $desc
      $desc = $current.find('ul')
    }
    $('li').removeClass(classes.bottomBorder)
    $current
      .find('li')
      .last()
      .addClass(classes.bottomBorder)
  }

  UNSAFE_componentWillReceiveProps() {
    const { activeTopMenuItem } = this.props
    if (activeTopMenuItem) {
      this.setState({
        activeTopMenuItem
      })
    }
  }

  render() {
    const { classes, items, isMenuToggled } = this.props
    const { base, hideOnMobile } = classes
    const className = isMenuToggled
      ? `${base}`
      : `${base} ${hideOnMobile} menuBase`

    map(items, (value, key) => {
      value.topMenuItem = key
    })

    return (
      <div className={className}>
        {this.renderItems(items, this.props, true, null, 0)}
      </div>
    )
  }

  getClassName(
    isTopLevel,
    isMobileOnly,
    isOnRoute,
    isDisabled,
    isPartOfActiveTopMenu,
    topItem,
    props
  ) {
    const { hideOnDesktop, active, inactive, disabled } = this.props.classes

    const { highlightedNavbarSection } = props
    let className = ''

    if (isMobileOnly) className = `${className} ${hideOnDesktop}`

    if (highlightedNavbarSection === topItem && isTopLevel) {
      className = `${className} ${active}`
    } else if (
      isOnRoute &&
      isPartOfActiveTopMenu &&
      !highlightedNavbarSection
    ) {
      className = `${className} ${active}`
    } else if (isPartOfActiveTopMenu && !isTopLevel && isOnRoute) {
      className = `${className} ${active}`
    } else className = `${className} ${inactive}`

    if (isDisabled) className = `${className} ${disabled}`

    return className
  }

  renderItems(items, props, isTopLevel, topMenuItem, menuItemIndex) {
    const { action, location, dispatch } = props

    return (
      <ul>
        {map(items, (value, key) => {
          let { _meta, subItems, isMobileOnly, isDisabled, uuid } = value
          _meta = _meta || {}

          const topItem = topMenuItem || value.topMenuItem
          const route = _meta.route || value.route
          const title = _meta.title || value.title
          const onClick = _meta.onClick || value.onClick
          const icon = _meta.icon || value.icon
          const isOnRoute = location.pathname.includes(route)
          const partsOfPath = route ? route.split('/') : ['']
          const lastSegmentPath = partsOfPath.pop() || partsOfPath.pop()

          const handleClick = e => {
            if (e) {
              e.stopPropagation()
              e.preventDefault()
            }

            if (isDisabled) return
            const payload = { route, topItem }

            const partsOfRoute = route ? route.split('/') : ['']
            const lastSegmentRoute = partsOfRoute.pop() || partsOfRoute.pop()

            if (dispatch && action) {
              // dont navigate if surveys are done and going to surveys

              if (
                !(props.isSurveysDone && lastSegmentRoute === 'assessments')
              ) {
                dispatch(action(payload))
              }
            }
            if (onClick) onClick()
            this.setState({
              activeTopMenuItem: topItem,
              activeSubMenu: route,
              activeItemIndex: menuItemIndex
            })
          }

          const isPartOfActiveTopMenu =
            this.state.activeTopMenuItem === topItem ||
            this.props.highlightedNavbarSection === topItem

          const isNotDirectChild = location.pathname !== route
          const hasSubItems = subItems
          const isExceptionToRoute =
            this.state.activeSubMenu === route &&
            (lastSegmentPath === 'assessments' || lastSegmentPath === 'visits')

          const isRenderSubItems =
            isNotDirectChild &&
            hasSubItems &&
            (isOnRoute || isExceptionToRoute) &&
            isPartOfActiveTopMenu

          return (
            <li
              key={key}
              id={uuid}
              onClick={handleClick}
              className={this.getClassName(
                isTopLevel,
                isMobileOnly,
                isOnRoute,
                isDisabled,
                isPartOfActiveTopMenu,
                topItem,
                props
              )}
            >
              <div className={`level-${menuItemIndex}`}>
                <span>{title}</span>
                {isDisabled ? (
                  <span>
                    <img src={LockedIcon} alt="locked" />
                  </span>
                ) : null}
                {icon && !isDisabled ? (
                  <span>
                    {icon.src ? (
                      <img src={icon.src} alt="icon" />
                    ) : (
                      <span className="textIcon">{icon.text}</span>
                    )}
                  </span>
                ) : null}
              </div>

              {isRenderSubItems
                ? this.renderItems(
                  subItems,
                  props,
                  false,
                  topItem,
                  menuItemIndex + 1
                )
                : null}
            </li>
          )
        })}
      </ul>
    )
  }

  checkSideBarShadows() {
    const menuFixedHeight =
      $('.sidebar').height() -
      $('.menu-header').height() -
      $('.menu-footer').height()

    const isMenuScrollable =
      $('.menuBase').scrollTop() <=
      $('.menuBase > ul').height() -
      menuFixedHeight -
      $('.level-0').height() / 5

    if ($('.menuBase').scrollTop() > 0 && !this.state.isTopScrollClassAdded) {
      $('.menu-header').addClass('menu-top-shadow')
      this.setState({
        isTopScrollClassAdded: true
      })
    } else if (
      $('.menuBase').scrollTop() < 1 &&
      this.state.isTopScrollClassAdded
    ) {
      $('.menu-header').removeClass('menu-top-shadow')
      this.setState({
        isTopScrollClassAdded: false
      })
    }

    if (isMenuScrollable && !this.state.isBottomScrollClassAdded) {
      $('.menu-footer').addClass('menu-bottom-shadow')
      this.setState({ isBottomScrollClassAdded: true })
    } else if (!isMenuScrollable && this.state.isBottomScrollClassAdded) {
      $('.menu-footer').removeClass('menu-bottom-shadow')
      this.setState({ isBottomScrollClassAdded: false })
    }
  }
}

export default injectSheet(() => style)(Menu)
